/** @jsxImportSource @emotion/react */
import { Box, Button, Typography } from '@mui/material';
import { css } from '@emotion/react';
import InvoiceWorkingListTable from './invoice-working-list-table';
import withHeader from '../../../../HOC/WithHeader';
import BackButton from '../../../../components/BackButton';
import { useNavigate, useParams } from 'react-router-dom';
import { ROUTES } from '../../../../routes/auth-routes/routes';
import { ReactComponent as DownloadIcon } from '../../../../../icons/svgs/download.svg';
import downloadInvoiceReportAPI from '../../request/get-invoice-working-report';

const InvoiceWorkingPage = () => {
  const navigate = useNavigate();
  const { payoutCommissionId } = useParams<{
    payoutCommissionId: string;
  }>();

  return (
    <div>
      <Box
        css={css`
          padding: 20px 80px;
          display: flex;
          flex-direction: column;
          align-items: flex-start;
          gap: 20px;
          flex: 1 0 0;
          align-self: stretch;
        `}
      >
        {/* <PayoutCommissionsListTable /> */}
        <Box>
          <BackButton
            onClick={() =>
              navigate(
                {
                  pathname: ROUTES.PAYOUT_COMMISSIONS_PAGE,
                },
                {
                  replace: true,
                }
              )
            }
          />
        </Box>
        <Box
          css={css`
            display: flex;
            justify-content: space-between;
            align-items: center;
            align-self: stretch;
          `}
        >
          <Typography
            css={css`
              color: var(--Neutral-Primary, #2d2d2d);
              font-family: Inter;
              font-size: 24px;
              font-style: normal;
              font-weight: 600;
              line-height: 140%; /* 33.6px */
              letter-spacing: -0.24px;
            `}
          >
            Invoice Working
          </Typography>
          <Button
            variant="contained"
            css={css`
              padding: 8px 22px;
              border-radius: 4px;
              font-size: 14px;
              font-weight: 600;
              text-transform: none;
              width: max-content;
              display: flex;
              align-items: center;
              gap: 8px;
              background: #fff;
              color: #3F906D;
              border: 1px solid #3F906D;
              &:hover {
                background: #3F906D;
                color: #fff;
                svg {
                  * {
                    stroke: #fff;
                  }
                }
              }
              svg {
                * {
                  stroke: #3F906D;
                }
              }
            `}
            onClick={() => payoutCommissionId && downloadInvoiceReportAPI(payoutCommissionId)}
          >
            <DownloadIcon />
            Download Invoice working
          </Button>
        </Box>
        <InvoiceWorkingListTable />
      </Box>
    </div>
  );
};

export default withHeader(InvoiceWorkingPage);
